import { useMemo } from 'react'
import Select from 'react-select'
import PropTypes from 'prop-types'
import { FormGroup, Label } from 'reactstrap'
import { useTranslation } from 'react-i18next'

const SelectYear = ({
  year = new Date().getFullYear(),
  defaultValue = new Date().getFullYear(),
  limit = 6,
  valueYear,
  onChange = () => {},
}) => {
  const options = Array.from(Array(limit), (e, i) => {
    const y = year - i
    return { value: y, label: `${y}` }
  })

  const defaultOption = options.find((v) => v.value === defaultValue)
  const { t } = useTranslation()

  const value = useMemo(() => {
    return options.find((x) => x.value === valueYear)
  }, [valueYear])

  return (
    <FormGroup>
      <Label>{t('year')}</Label>
      <Select options={options} defaultValue={defaultOption} onChange={onChange} value={value} />
    </FormGroup>
  )
}

export default SelectYear

SelectYear.propTypes = {
  year: PropTypes.number,
  limit: PropTypes.number,
  defaultValue: PropTypes.number,
  onChange: PropTypes.func,
  valueYear: PropTypes.number,
}
